export default __webpack_public_path__ + "static/media/crosswbgicon.05e31463.svg";